import BG from "../../BG";
import Header from "../../Header";
import Body from "../../Body";
import Title from "../../Title";
import Subtitle from "../../Subtitle";
import Text from "../../Text";
import ButtonGroups from "../../ButtonGroups";
import Button from "../../Button";
import Image from "../../Image";
import setCurrentPage from "src/Utils/setCurrentPage";

interface TemplateProps {
  data: DataJourneyOne;
}

const Template = (props: TemplateProps) => {
  const {
    bgImage,
    title,
    subtitle,
    text,
    rightSideImage,
    rightSideComponent,
    next,
    back,
    headerRightText,
    headerLeftImage,
  } = props.data;

  const templateType = "journey-one-template";

  return (
    <BG bgImage={bgImage}>
      <Header
        onClickHome={() => setCurrentPage(1)}
        rightText={headerRightText}
        leftImage={headerLeftImage}
      />
      <Body>
        <div style={styles.container}>
          <div style={styles.panelLeft}>
            <Subtitle
              style={{ marginTop: "66px" }}
              type={templateType}
              text={subtitle}
            />
            <div>
              <Title type={templateType} text={title} />
              <Text
                style={{ marginTop: "16px" }}
                type={templateType}
                text={text}
              />
            </div>
            <div>
              <ButtonGroups>
                {back !== null && <Button {...back} />}
                {next !== null && <Button {...next} />}
              </ButtonGroups>
            </div>
          </div>
          {rightSideImage && (
            <Image
              style={styles.panelRight}
              styleImage={styles.image}
              imagePath={rightSideImage}
            />
          )}
          {rightSideComponent && rightSideComponent}
        </div>
      </Body>
    </BG>
  );
};

const styles = {
  container: {
    display: "flex",
    height: "-webkit-fill-available",
  },
  panelLeft: {
    zIndex: 2,
    flex: 1,
    height: "-webkit-fill-available",
    display: "flex" as React.CSSProperties["display"],
    flexDirection: "column" as React.CSSProperties["flexDirection"],
    justifyContent: "space-between",
  },
  panelRight: {
    flex: 1,
  },
  image: {
    position: "absolute" as React.CSSProperties["position"],
    top: 0,
    right: 0,
  },
};

export default Template;
